import { createContext, FC, ReactNode, useState, useContext } from 'react';
import { useUID, UID } from 'dibs-uid';
// DO NOT EXPORT TO CONSUMERS OUTSIDE OF DIBS-ELEMENTS
type SetLabelActive = (active: boolean) => void;

type ModalData = { labelUid: UID; modalUid: string; setLabelActive: SetLabelActive };

export const ModalContext = createContext<ModalData>({
    labelUid: null,
    modalUid: 'Modal',
    setLabelActive: () => {},
});

export const ModalProvider: FC = ({ children }) => {
    const [labelActive, setLabelActive] = useState(false);
    const labelUid = useUID();
    const modalUid = useUID();
    const nonNullModalId = `Modal${modalUid || ''}`;
    const activeLabelUid = labelActive ? labelUid : null;
    return (
        <ModalContext.Provider
            value={{ modalUid: nonNullModalId, labelUid: activeLabelUid, setLabelActive }}
        >
            {children}
        </ModalContext.Provider>
    );
};

export const ModalConsumer: FC<{
    children: (modalData: ModalData) => ReactNode;
}> = ({ children }) => {
    const modalData = useContext(ModalContext);
    return <>{children(modalData)}</>;
};
